<div class="checkbox-wrapper dis-flex flex-c">
  <div class="dis-flex flex-m m-l-10 m-r-10">
    <p-checkbox
      [(ngModel)]="notStarted"
      class="kanban-not-started-cb"
      label="Not Started"
      name="status"
      value="Not Started"
      binary="true"
    />
  </div>
  <div class="dis-flex flex-m m-l-10 m-r-10">
    <p-checkbox
      [(ngModel)]="ongoing"
      class="kanban-ongoing-cb"
      label="Ongoing"
      name="status"
      value="Ongoing"
      binary="true"
    />
  </div>
  <div class="dis-flex flex-m m-l-10 m-r-10">
    <p-checkbox
      [(ngModel)]="completed"
      class="kanban-completed-cb"
      label="Completed"
      name="status"
      value="Completed"
      binary="true"
    />
  </div>
  <div class="dis-flex flex-m m-l-10 m-r-10">
    <p-checkbox
      [(ngModel)]="delayed"
      class="kanban-delayed-cb"
      label="Delayed"
      name="status"
      value="Delayed"
      binary="true"
    />
  </div>
  <div class="dis-flex flex-m m-l-10 m-r-10">
    <p-checkbox
      [(ngModel)]="terminated"
      class="kanban-terminated-cb"
      label="Terminated"
      name="status"
      value="Terminated"
      binary="true"
    />
  </div>
</div>
<div class="kanban-column-wrapper">
  <div class="kanban-column not-started-col" *ngIf="notStarted">
    <div class="col-title">
      <div class="icon-wrapper">
        <ng-icon name="hugeFolderRemove" size="14" color="var(--grey-100)" />
      </div>
      <p class="m-b-0 b1 font-medium text-10">Not Started</p>
      <p class="caption m-b-0 m-l-10 m-t-1 text-10">
        ({{ notStartedCount }} item)
      </p>
    </div>
    <div class="col-body">
      <app-virtual-scroll
        class="w-full"
        *ngIf="notStartedCount > 0; else noData"
        [data]="payloadData"
        [apiUrl]="kanbanUrl"
        [outcome_status]="{ outcome_status: '1' }"
        (loadedData)="onDataLoaded($event, 'notstarted')"
      >
        <app-kanban-card
          *ngFor="let kanbanitem of notstartedData"
          [kanbanData]="kanbanitem"
          [outcomeType]="kanbanPayload.outcome_type"
          [category]="this.category"
        ></app-kanban-card>
      </app-virtual-scroll>
    </div>
  </div>
  <div class="kanban-column ongoing-col" *ngIf="ongoing">
    <div class="col-title">
      <div class="icon-wrapper">
        <ng-icon name="hugeClock05" size="14" color="var(--warning)" />
      </div>
      <p class="m-b-0 b1 font-medium text-10">Ongoing</p>
      <p class="caption m-b-0 m-l-10 m-t-1 text-10">
        ({{ ongoingCount }} item)
      </p>
    </div>
    <div class="col-body">
      <app-virtual-scroll
        class="w-full"
        *ngIf="ongoingCount > 0; else noData"
        [data]="payloadData"
        [apiUrl]="kanbanUrl"
        [outcome_status]="{ outcome_status: '2' }"
        (loadedData)="onDataLoaded($event, 'ongoing')"
      >
        <app-kanban-card
          *ngFor="let kanbanitem of ongoingData"
          [kanbanData]="kanbanitem"
          [outcomeType]="kanbanPayload.outcome_type"
          [category]="this.category"
        ></app-kanban-card>
      </app-virtual-scroll>

    </div>
  </div>
  <div class="kanban-column completed-col" *ngIf="completed">
    <div class="col-title">
      <div class="icon-wrapper">
        <ng-icon name="hugeFolderCheck" size="14" color="var(--success)" />
      </div>
      <p class="m-b-0 b1 font-medium text-10">Completed</p>
      <p class="caption m-b-0 m-l-10 m-t-1 text-10">
        ({{ completedCount }} item)
      </p>
    </div>
    <div class="col-body">
      <app-virtual-scroll
        class="w-full"
        *ngIf="completedCount > 0; else noData"
        [data]="payloadData"
        [apiUrl]="kanbanUrl"
        [outcome_status]="{ outcome_status: '3' }"
        (loadedData)="onDataLoaded($event, 'completed')"
      >
        <app-kanban-card
          *ngFor="let kanbanitem of completedData"
          [kanbanData]="kanbanitem"
          [outcomeType]="kanbanPayload.outcome_type"
          [category]="this.category"
        ></app-kanban-card>
      </app-virtual-scroll>
    </div>
  </div>
  <div class="kanban-column delayed-col" *ngIf="delayed">
    <div class="col-title">
      <div class="icon-wrapper">
        <ng-icon name="hugeAlert02" size="14" color="var(--error)" />
      </div>
      <p class="m-b-0 b1 font-medium text-10">Delayed</p>
      <p class="caption m-b-0 m-l-10 m-t-1 text-10">
        ({{ delayedCount }} item)
      </p>
    </div>
    <div class="col-body">
      <app-virtual-scroll
        class="w-full"
        *ngIf="delayedCount > 0; else noData"
        [data]="payloadData"
        [apiUrl]="kanbanUrl"
        [outcome_status]="{ outcome_status: '4' }"
        (loadedData)="onDataLoaded($event, 'delayed')"
      >
        <app-kanban-card
          *ngFor="let kanbanitem of delayedData"
          [kanbanData]="kanbanitem"
          [outcomeType]="kanbanPayload.outcome_type"
          [category]="this.category"
        ></app-kanban-card>
      </app-virtual-scroll>
    </div>
  </div>
  <div class="kanban-column terminated-col" *ngIf="terminated">
    <div class="col-title">
      <div class="icon-wrapper">
        <ng-icon
          name="hugeCancelCircleHalfDot"
          size="14"
          color="var(--red-extra-dark)"
        />
      </div>
      <p class="m-b-0 b1 font-medium text-10">Terminated</p>
      <p class="caption m-b-0 m-l-10 m-t-1 text-10">
        ({{ terminatedCount }} item)
      </p>
    </div>
    <div class="col-body">
      <app-virtual-scroll
        class="w-full"
        *ngIf="terminatedCount > 0; else noData"
        [data]="payloadData"
        [apiUrl]="kanbanUrl"
        [outcome_status]="{ outcome_status: '5' }"
        (loadedData)="onDataLoaded($event, 'terminated')"
      >
        <app-kanban-card
          *ngFor="let kanbanitem of terminatedData"
          [kanbanData]="kanbanitem"
          [outcomeType]="kanbanPayload.outcome_type"
          [category]="this.category"
        ></app-kanban-card>
      </app-virtual-scroll>
    </div>
  </div>
</div>
<ng-template #noData>
  <img src="assets/images/no_data_found.png" alt="No Data" class="no-data-img" />
</ng-template>
